import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function useFemaleLevelRules() {
  const [rules, setRules] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, "levelRules", "female"));

        if (!snap.exists()) {
          setRules({
            levels: [
              { level: 0, requiredTokens: 0, requiredDays: 0 },
              { level: 1, requiredTokens: 100, requiredDays: 0 },
              { level: 2, requiredTokens: 1500, requiredDays: 5 },
              { level: 3, requiredTokens: 4000, requiredDays: 5 },
              { level: 4, requiredTokens: 10000, requiredDays: 5 },
              { level: 5, requiredTokens: 25000, requiredDays: 5 },
              { level: 6, requiredTokens: 70000, requiredDays: 6 },
              { level: 7, requiredTokens: 150000, requiredDays: 6 },
              { level: 8, requiredTokens: 300000, requiredDays: 7 },
              { level: 9, requiredTokens: 550000, requiredDays: 7 },
              { level: 10, requiredTokens: 1000000, requiredDays: 7 },
            ],
          });
          return;
        }

        const data = snap.data() || {};

        const normalizedLevels = Array.isArray(data.levels)
          ? data.levels
              .map((lv) => ({
                level: Number(lv?.level ?? 0),
                requiredTokens: Number(
                  lv?.requiredTokens ??
                    lv?.requiredPoints ??
                    lv?.amount ??
                    0
                ),
                requiredDays: Number(lv?.requiredDays ?? 0),
              }))
              .sort((a, b) => a.level - b.level)
          : [];

        setRules({
          ...data,
          levels: normalizedLevels,
        });
      } catch (err) {
        console.error("❌ useFemaleLevelRules error:", err);
        setRules(null);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return { rules, loading };
}